<template>
  <div class="group-setup">
    <v-progress-linear indeterminate color="orange" v-if="loading"></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Project Information</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form class="pa-5" v-if="!loading">
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-select v-model="form.governor_theme_id" :items="themeList" :item-text="'theme'" :item-value="'uuid'"
              label="Theme" dense outlined @change="themeChange()"></v-select>
          </v-col>
        </v-row>
        <v-row v-if="showTreeType">
          <v-col cols="12" md="12" sm="12">
            <v-select v-model="form.tree_type" :items="treeTypeList" :item-text="'label'" :item-value="'value'"
              label="Tree Type*" dense outlined></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-checkbox v-model="form.is_lion_ladies" label="Project by Lion Ladies Association" dense></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.venue" label="Venue*" required></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <DatePicker :lable="'Date*'" v-model="form.date" :setectVale="form.date" @changeInput="form.date = $event">
            </DatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.total_project_cost" label="Actual Total Project Cost (Rs.)*"
              required></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.direct_beneficiaries" label="Direct Beneficiaries*"
              required :max="directMax"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.indirect_beneficiaries" label="Indirect Beneficiaries*"
              required :max="indirectMax"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" sm="12">
            <v-textarea outlined dense v-model="form.description" label="Brief Description of the Project*">
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field outlined dense v-model="form.video_url" label="Video URL">
            </v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12" v-if="showSocialMediaViews">
            <v-text-field outlined dense v-model="form.social_media_views" type="number" min="0"
              label="Social Media Views*"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input outlined dense filled v-model="form.billing_proof" prepend-icon="mdi-paperclip"
              label="Please attache billing proof *"></v-file-input>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input outlined dense filled v-model="form.int_report_screenshot" prepend-icon="mdi-paperclip"
              label="Please attache international reporting screenshot *"></v-file-input>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading || !form.governor_theme_id" block
              @click="submit()">Next</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="succesMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="clossSnackbar" />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { CommonService } from "../../../../services/common-service.js";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",

  components: { Alert, Snackbars, DatePicker },
  props: ["uuid"],
  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    succesMsg: "",
    themeList: [],
    showLargeTree: false,
    showSmallTree: false,
    showTreeType: false,
    showSocialMediaViews: false,
    treeTypeList: [
      { label: "Long Lifespan (Teak, Coconut)", value: "LONG_LIFESPAN" },
      { label: "Short Lifespan (Vegetables)", value: "SHORT_LIFESPAN" }
    ],
    form: {
      venue: "",
      description: "",
      date: null,
      total_project_cost: null,
      number_of_beneficiaries: null,
      governor_theme_id: null,
      billing_proof: null,
      int_report_screenshot: null,
      small_tree: 0,
      large_tree: 0,
      tree_type: null,
      is_lion_ladies: false,
      social_media_views: 0,
      direct_beneficiaries: null,
      indirect_beneficiaries: null,
      video_url: null
    },
    role: localStorage.getItem('role') || null


  }),

  mounted() {
    this.getGovernorThemes();
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
    directMax() {
      const theme = this.themeList.find((v) => v.uuid == this.form.governor_theme_id);
      return theme && theme.theme_key == 'promoting_tourism' ? 200000 : 1000;
    },
    indirectMax() {
      return 1000;
    },
  },

  methods: {
    submit() {
      this.loading = true;
      let fd = new FormData();
      fd.append("billing_proof", this.form.billing_proof);
      fd.append("int_report_screenshot", this.form.int_report_screenshot);
      fd.append("venue", this.form.venue);
      fd.append("description", this.form.description);
      fd.append("date", this.form.date);
      fd.append("total_project_cost", this.form.total_project_cost);
      fd.append("indirect_beneficiaries", this.form.indirect_beneficiaries);
      fd.append("direct_beneficiaries", this.form.direct_beneficiaries);
      fd.append("governor_theme_id", this.form.governor_theme_id);
      fd.append("small_tree", this.form.small_tree);
      fd.append("large_tree", this.form.large_tree);
      fd.append("tree_type", this.form.tree_type);
      fd.append("is_lion_ladies", this.form.is_lion_ladies ? 1 : 0);
      fd.append("social_media_views", this.form.social_media_views);
      fd.append("video_url", this.form.video_url);
      ProjectService.createProjectInfo(fd)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.succesMsg = "Success";
            this.snackbar = true;
            this.$router.push({
              name: "ProjectEdit",
              params: { step: 2, uuid: response.data.data.uuid },
            });

            this.reset();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    themeChange() {
      this.showTreeType = false;
      this.form.tree_type = null;
      this.showSocialMediaViews = false;

      this.themeList.forEach((value) => {
        if (value.theme_key == 'environment' && this.form.governor_theme_id == value.uuid) {
          this.showTreeType = true;
        }
        if (value.theme_key == 'promoting_tourism' && this.form.governor_theme_id == value.uuid) {
          this.showSocialMediaViews = true;
        }
      });
    },



    getGovernorThemes() {
      if (this.uuid !== null) {
        this.loading = true;
        CommonService.getGovernorThemes()
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.themeList = response.data.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.themeList = [];
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },

    onDismissed() {
      this.errors = null;
    },
    clossSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form = [];
    },
  },
};
</script>
